<template>
  <div class="game-item" :class="[
    `rounded-${rounded}`,
  ]" ref="gameItemRef" @click.prevent.stop="handleClick">

    <!-- 图片加载中 -->
    <div v-if="isLoading || isError" class="loading-overlay"></div>

    <!-- 封面 -->
    <div v-show="!isError" class="item-cover">
      <img v-if="isInViewport" :src="item.imageUrl || item.logo" @error="onImgError" @load="onImgLoad"
        class="absolute w-full overflow-hidden rounded-inherit" />
    </div>
    <!-- 标题 -->
    <!-- <div v-if="item.mfr_id !== 8"
      class="title w-full ellipsis text-color-0 text-center absolute l-0 text-12 font-700 px-5 z-10"
      :style="{ bottom: item.mfr_id === 7 ? '3.96%' : '6.96%' }">{{ item.game_name }}</div> -->
    <!-- JILI -->
    <!-- <div v-if="isError && item.mfr_id === 8"
      class="title w-full ellipsis text-color-0 text-center absolute l-0 text-12 px-5 z-10"
      :style="{ bottom: item.mfr_id === 7 ? '3.96%' : '6.96%' }">
      {{ item.game_name }}
    </div> -->
    <!-- 左上角标签 -->
    <!-- 热门 -->
    <!-- <div class="item-tag absolute t-0 l-0" v-if="item.is_hot == 1">
      <div class="tag text-color-0 flex justify-center items-center font-700 text-13 px-5 h-19">
        {{ $t("A0273") }}
      </div>
    </div> -->
    <!-- 最新 -->
    <!-- <div class="item-tag absolute t-0 l-0" v-if="item.head_tags == 2">
      <div class="tag text-color-0 flex justify-center items-center font-700 text-13 px-5 h-19">
        {{ $t("A0274") }}
      </div>
    </div> -->
    <div class="absolute t-5 r-5">
      <div class="favorite-btn" @click.stop="toggleFavorite(item)">
        <!-- 半透明圆背景 -->
        <div class="circle-bg"></div>

        <!-- 星星 -->
        <svg viewBox="0 0 1024 1024" class="star-icon">
          <path
            d="M877.632 456.8c14.976-14.72 20.384-32.96 14.816-49.984-5.536-17.024-20.608-28.544-41.344-31.584l-190.24-27.84c-6.976-1.024-18.464-9.472-21.6-15.904l-85.12-173.696c-9.28-18.944-24.896-29.76-42.88-29.76-17.952 0-33.6 10.816-42.816 29.76l-85.12 173.696c-3.104 6.432-14.592 14.848-21.6 15.904l-190.24 27.84c-20.704 3.04-35.776 14.56-41.344 31.584-5.568 17.024-0.16 35.232 14.816 49.984l137.696 135.232c5.088 4.992 9.536 18.816 8.32 25.92l-32.48 190.912c-3.552 20.832 2.752 38.816 17.344 49.344 7.52 5.44 16.224 8.16 25.472 8.16 8.576 0 17.6-2.336 26.56-7.04l170.176-90.176c6.048-3.2 20.448-3.2 26.528 0l170.144 90.112c18.528 9.856 37.504 9.44 52.064-1.056 14.56-10.528 20.864-28.48 17.344-49.28l-32.48-190.976c-1.28-7.104 3.2-20.928 8.32-25.92l137.664-135.232z"
            :fill="item.is_collect ? '#f68509' : 'rgba(105,105,105,0.6)'"
          />
        </svg>
      </div>
    </div>
    <!-- <div class="absolute t-5 r-5">
      <div style="display: flex;align-items: center;justify-content: center;background: rgba(255,255,255,0.8);width: 20px;height: 20px;border-radius: 20px;padding: 2px;">
        <svg t="1763370751051" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="29297" width="256" height="256"><path d="M877.632 456.8c14.976-14.72 20.384-32.96 14.816-49.984-5.536-17.024-20.608-28.544-41.344-31.584l-190.24-27.84c-6.976-1.024-18.464-9.472-21.6-15.904l-85.12-173.696c-9.28-18.944-24.896-29.76-42.88-29.76-17.952 0-33.6 10.816-42.816 29.76l-85.12 173.696c-3.104 6.432-14.592 14.848-21.6 15.904l-190.24 27.84c-20.704 3.04-35.776 14.56-41.344 31.584-5.568 17.024-0.16 35.232 14.816 49.984l137.696 135.232c5.088 4.992 9.536 18.816 8.32 25.92l-32.48 190.912c-3.552 20.832 2.752 38.816 17.344 49.344 7.52 5.44 16.224 8.16 25.472 8.16 8.576 0 17.6-2.336 26.56-7.04l170.176-90.176c6.048-3.2 20.448-3.2 26.528 0l170.144 90.112c18.528 9.856 37.504 9.44 52.064-1.056 14.56-10.528 20.864-28.48 17.344-49.28l-32.48-190.976c-1.28-7.104 3.2-20.928 8.32-25.92l137.664-135.232z" fill="none"
        stroke="rgba(0,0,0,0)" stroke-width="50" p-id="29298"></path></svg>
        <svg t="1763370751051" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="29297" width="64" height="64"><path d="M877.632 456.8c14.976-14.72 20.384-32.96 14.816-49.984-5.536-17.024-20.608-28.544-41.344-31.584l-190.24-27.84c-6.976-1.024-18.464-9.472-21.6-15.904l-85.12-173.696c-9.28-18.944-24.896-29.76-42.88-29.76-17.952 0-33.6 10.816-42.816 29.76l-85.12 173.696c-3.104 6.432-14.592 14.848-21.6 15.904l-190.24 27.84c-20.704 3.04-35.776 14.56-41.344 31.584-5.568 17.024-0.16 35.232 14.816 49.984l137.696 135.232c5.088 4.992 9.536 18.816 8.32 25.92l-32.48 190.912c-3.552 20.832 2.752 38.816 17.344 49.344 7.52 5.44 16.224 8.16 25.472 8.16 8.576 0 17.6-2.336 26.56-7.04l170.176-90.176c6.048-3.2 20.448-3.2 26.528 0l170.144 90.112c18.528 9.856 37.504 9.44 52.064-1.056 14.56-10.528 20.864-28.48 17.344-49.28l-32.48-190.976c-1.28-7.104 3.2-20.928 8.32-25.92l137.664-135.232z" fill="#f68509"
        stroke="currentColor" p-id="29298"></path></svg>
      </div>
    </div> -->
  </div>
</template>
<script setup>
import { apiGameCollect,apiGameDiscollect } from "@/api";
import { useNav } from "@/hooks/useNav";
import { useUserStore } from "@/stores/modules/user";
import { useGameStore } from "@/stores/modules/game";
import { useI18n } from "vue-i18n";
import eventBus from '@/utils/eventBus'
const { t } = useI18n();
const gameStore = useGameStore();
const emit = defineEmits(["onclick","oncollectsuccess"]);
const { proxy } = getCurrentInstance();
const props = defineProps({
  item: {
    type: Object,
    default: {}
  },
  rounded: {
    type: [Number, String],
    default: 10
  },
});
const gameItemRef = ref(null)
const isLoading = ref(true)
const isError = ref(false)
const nav = useNav();
const userStore = useUserStore();
const isInViewport = ref(false);  // 新增：判断元素是否在视口内
// 使用 IntersectionObserver 来判断元素是否出现在视口内
onMounted(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // console.log(entry.isIntersecting)
          isInViewport.value = true;
          isLoading.value = true
          observer.unobserve(entry.target); // 只需要触发一次
        }
      });
    },
    {
      rootMargin: '0px',
      threshold: 0.1,  // 视口进入 10% 时触发
    }
  );
  observer.observe(gameItemRef.value);
});
const isLogin = computed(() => {
  return userStore.isLogin;
});
async function toggleFavorite(item) {
  console.log(item)
  if (!isLogin.value) {
    // handleClose();
    eventBus.emit("Login", 'in');
    return;
  }
  proxy.$Loading.show();
  let code = null;
  try {
    if(item.is_collect === 0){
      const res = await apiGameCollect({ game_id: item.id });
      code = res.code;
    }else if(item.is_collect === 1){
      const res = await apiGameDiscollect({ game_id: item.id });
      code = res.code;
    }
    if (code === 200) {
      proxy.$Toast(item.is_collect === 0 ? t("A0351") : t("A0352"));
      item.is_collect = item.is_collect === 0 ? 1 : 0;

      gameStore.updateLast7DaysGame(item);
      emit("oncollectsuccess", {
        id: item.id,
        is_collect: item.is_collect
      });
    }
  } catch (error) {
    console.log("error?",error)
  } finally {
    proxy.$Loading.hide();
  }
}
function handleClick() {
  emit("onclick", props.item);
}
// 图片加载完成
function onImgLoad() {
  isLoading.value = false;
}
// 图片加载失败
function onImgError() {
  isLoading.value = false;
  isError.value = true;  // 设置加载失败标志
}
</script>
<style lang="scss" scoped>
.game-item {
  height: 0;
  position: relative;
  overflow: hidden;
  padding-bottom: 133.33%;
  background-color: #1e1f22;
  box-shadow: 0 4px 10px rgba(0, 40, 50, 0.15);
  


  .loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #1e1f22;
    animation: 0.8s linear 0s infinite alternate none running animation-14pkoxc;
  }

  @keyframes animation-14pkoxc {
    0% {
      background-color: #090a0d;
    }

    100% {
      background-color: #1e1f22;
    }
  }

  .item-cover {
    width: 100%;
    height: 0;
    padding-bottom: 133.33%;
    background: white;
    box-shadow: 0 4px 10px rgba(0, 40, 50, 0.15);

    img {
      width: 100%;
      -webkit-box-reflect: below 0px linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.1));
      pointer-events: none;
      transition: 0.5s;
    }
  }

  .item-tag {
    .tag {
      background: linear-gradient(90deg, #f90, #ec0039);
      border-radius: 10px 0;
    }
  }
}
.favorite-btn {
  position: relative;
  width: 20px;
  height: 20px;
  cursor: pointer;

  .circle-bg {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: rgba(255,255,255,0.8);
  }

  .star-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 16px;
    height: 16px;
    transform: translate(-50%, -50%);
  }
}
</style>
